import { get } from 'lodash-es'
import { KEY_PROPERTY_SEPARATOR } from '@/components/combined-predict/models/epiSuite/epiSuiteColumnGroups'

const replaceSeparatorsOnDots = (str) => {
  if (typeof str !== 'string') return str
  return str.replaceAll(KEY_PROPERTY_SEPARATOR, '.')
}

const getPredictionDataBySource = (item, path) => get(item, replaceSeparatorsOnDots(path), null)

const getEcosarPredictionForOrganismByProperty = (predictionForProperty, sourceType) => {
  const [resultsKey, qsarClass, endpoint, organism] = sourceType.split(KEY_PROPERTY_SEPARATOR)
  const results = get(predictionForProperty, resultsKey, [])
  return (
    results?.find(
      (result) => result.organism === organism && result.endpoint === endpoint && result.qsarClass === qsarClass,
    ) ?? null
  )
}

const getEcosarPredictionByProperty = (predictionForProperty, sourceType) => {
  const predictionForOrganism = getEcosarPredictionForOrganismByProperty(predictionForProperty, sourceType)
  return get(predictionForOrganism, 'concentration', null)
}

const getHydrolysisPredictionByProperty = (predictionForProperty, sourceType) => {
  const [resultsKey, ph] = sourceType.split(KEY_PROPERTY_SEPARATOR)
  const results = get(predictionForProperty, resultsKey, [])
  if (!results?.length) return null

  return (
    results.find((result) => {
      const numberPh = Number(ph)
      return result.ph === numberPh && !!result.value
    }) ?? null
  )
}

export {
  getPredictionDataBySource,
  getEcosarPredictionByProperty,
  getHydrolysisPredictionByProperty,
  getEcosarPredictionForOrganismByProperty,
}
